const FOKUSERBARE =
  'a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';

/** Flytt fokus inn ved åpning og gjenopprett åpnerens fokus ved lukking. */
export function startDialogFokus(dialog: HTMLElement): () => void {
  const forrige = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  dialog.focus({ preventScroll: true });
  return () => {
    if (forrige?.isConnected) forrige.focus({ preventScroll: true });
  };
}

/** Escape lukker dialogen, og Tab/Shift+Tab kan ikke flytte fokus ut av den. */
export function handterDialogTastatur(
  event: KeyboardEvent,
  dialog: HTMLElement,
  lukk: () => void,
): void {
  if (event.key === 'Escape') {
    event.preventDefault();
    lukk();
    return;
  }
  if (event.key !== 'Tab') return;

  const fokuserbare = [...dialog.querySelectorAll<HTMLElement>(FOKUSERBARE)].filter(
    (element) => element.tabIndex >= 0 && !element.closest('[hidden], [inert], [aria-hidden="true"]'),
  );
  const forst = fokuserbare[0];
  const sist = fokuserbare[fokuserbare.length - 1];
  const aktiv = document.activeElement;

  if (!forst || !sist) {
    event.preventDefault();
    dialog.focus({ preventScroll: true });
  } else if (event.shiftKey && (aktiv === dialog || aktiv === forst || !dialog.contains(aktiv))) {
    event.preventDefault();
    sist.focus({ preventScroll: true });
  } else if (!event.shiftKey && (aktiv === dialog || aktiv === sist || !dialog.contains(aktiv))) {
    event.preventDefault();
    forst.focus({ preventScroll: true });
  }
}
